import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Input, Row} from "antd";
import {useNavigate} from "react-router-dom";
import HelpVideoLoader from "../../Components/HelpVideoLoader";
import {useTranslations} from "../../lang";

export default function Welcome() {

    const [eventSend, setEventSend] = useState(false)
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {translate} = useTranslations()

    useEffect(() => {
        if (eventSend) {
            return
        }
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'lead', {'send_to': 'AW-939836725/ZCERCOuLqv8BELWKk8AD'});
        }
        setEventSend(true)
    });

    return (
        <Row justify={"center"}>
            <Col className={"text-center"} md={18} xs={24}>
                <h1>{translate('Welkom!')}</h1>
                <p>{translate('Welkom bij de club van oogsters!')}</p>

                <h2>{translate('Wat wil je gaan oogsten?')}</h2>
                <Row justify={"center"}>
                    <Col xs={24} md={12}>
                        <Form form={form} layout={"horizontal"} onFinish={(values) => {
                            navigate('/crops?search=' + values.query + "&onboarding=1")
                        }}>
                            <Form.Item label={""} name={"query"}>
                                <Input size={"large"} placeholder={translate('Tomaat')}/>
                            </Form.Item>
                            <Form.Item>
                                <Button htmlType={"submit"} type={"primary"} size={"large"}>{translate('Volgende')}</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>

                <h1>{translate('Kijk eerst deze video')}</h1>
                <HelpVideoLoader/>
            </Col>
        </Row>
    )
}